import React from 'react';
import { IconButton } from '@components';
import { CloseIcon } from '@icons';
import { Title } from './title';

export interface ModalTitleProps {
    onClose: () => void;
}

export const ModalTitle = (props: React.PropsWithChildren<ModalTitleProps>): JSX.Element => {
    const { onClose, children } = props;

    return <Title trailing={<IconButton iconSize='24px' icon={<CloseIcon />} onClick={onClose} />}>
        {children}
    </Title>;
}